// extracted by mini-css-extract-plugin
export default {"container":"clients_container__Dy9Jl","header":"clients_header__EZTMd","clientListStyle":"clients_clientListStyle__7N50t","loaderContainer":"clients_loaderContainer__P91v6"};